import { BlobUploadCommonResponse, BlockBlobClient } from '@azure/storage-blob';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { filesActionCreators } from '..';
import { IState } from '../..';
import { getAzureStorageSas } from '../filesApi';
import { IAzureUpload, SasTokenRequestType } from '../filesInterfaces';

export const uploadToAzure = createAsyncThunk<BlobUploadCommonResponse, IAzureUpload, { state: IState }>(
  'files/uploadToAzure',
  async (request: IAzureUpload, { dispatch, getState, rejectWithValue }) => {
    const { containerType, file, folder, metadata, successAction } = request;
    const {
      config: { blobStorage }
    } = getState();
    const baseUrl = blobStorage?.baseUrl;
    const container = blobStorage ? blobStorage[containerType] : '';

    if (baseUrl && container) {
      const sas = await getAzureStorageSas(SasTokenRequestType.Write);
      const url = `${containerType}/${folder}/${file.name}`;

      const client = new BlockBlobClient(
        `BlobEndpoint=${baseUrl};SharedAccessSignature=${sas.sas}`,
        container,
        `${folder}${folder.endsWith('/') ? '' : '/'}${file.name}`
      );

      const response = await client.uploadBrowserData(file, {
        blobHTTPHeaders: {
          blobContentType: file.type
        },
        metadata,
        onProgress: p => {
          dispatch(filesActionCreators.uploadProgress({ url, amount: p.loadedBytes / file.size }));
        }
      });

      if (successAction) {
        dispatch(successAction);
      }

      return response;
    }

    return rejectWithValue('Invalid');
  }
);

// function* uploadToAzureSaga(action: ReturnType<typeof filesActionCreators.uploadToAzure>) {
//   const { containerType, file, folder, metadata } = action.payload;

//   if (baseUrl && container) {
//     const sas = yield* call(getAzureStorageSas, SasTokenRequestType.Write);
//     const client = new BlockBlobClient(
//       `BlobEndpoint=${baseUrl};SharedAccessSignature=${sas.sas}`,
//       container,
//       `${folder}${folder.endsWith('/') ? '' : '/'}${file.name}`
//     );

//     // console.log(client);
//     // yield call(async () =>
//     //   client
//     //     .uploadBrowserData(file, {
//     //       metadata,
//     //       *onProgress(progress) {
//     //         console.log(progress);
//     //         yield put(
//     //           filesActionCreators.uploadProgress({
//     //             amount: progress.loadedBytes / file.size,
//     //             url
//     //           })
//     //         );
//     //       }
//     //     })
//     //     .then(function*(resp) {
//     //       console.log(resp);
//     //       yield put(filesActionCreators.uploadSuccess({ file, url }));
//     //     })
//     //     .catch(function*(error) {
//     //       console.log('error', error);
//     //       yield put(filesActionCreators.uploadFailure({ error, file, url }));
//     //     })
//     // );
//     const func = function*() {
//       return client.uploadBrowserData(file, {
//         metadata,
//         *onProgress(progress) {
//           yield put(
//             filesActionCreators.uploadProgress({
//               amount: progress.loadedBytes / file.size,
//               url
//             })
//           );
//         }
//       });
//     };

//     try {
//       const result = yield* func();
//       console.log(result);

//       yield put(filesActionCreators.uploadSuccess({ file, url }));
//     } catch (error) {
//       console.log('error', error);
//       yield put(filesActionCreators.uploadFailure({ error, file, url }));
//     }
//   }
// }

// export function* watchUploadToAzure() {
//   yield takeEvery(filesActionCreators.uploadToAzure.match, uploadToAzureSaga);
// }
